<template>
    <b-modal title="Add A Product Group" id="addProductGroupModal" hide-footer>
        <b-overlay :show="busySaving">
            <b-form>
                <b-form-group id="example-input-group-1" label="Name" label-for="example-input-1">
                    <b-form-input
                        id="example-input-1"
                        name="example-input-1"
                        v-model="$v.form.name.$model"
                        :state="validateState('name')"
                        aria-describedby="input-1-live-feedback"
                    ></b-form-input>

                    <b-form-invalid-feedback id="input-1-live-feedback"
                        >This is a required field and must be at least 2 characters.</b-form-invalid-feedback
                    >
                </b-form-group>

                <b-form-group id="example-input-group-1" label="Description" label-for="example-input-1">
                    <b-form-input
                        id="example-input-1"
                        name="example-input-1"
                        v-model="$v.form.description.$model"
                        :state="validateState('description')"
                        aria-describedby="input-1-live-feedback"
                    ></b-form-input>

                    <b-form-invalid-feedback id="input-1-live-feedback"
                        >This is a required field and must be at least 2 characters.</b-form-invalid-feedback
                    >
                </b-form-group>
                <b-form-checkbox
                    id="checkbox-1"
                    v-model="form.display_material"
                    name="checkbox-1"
                    value="true"
                    unchecked-value="false"
                    class="mt-4 mb-2 ml-1"
                    switch
                >
                    Display Material
                </b-form-checkbox>
                <b-form-checkbox
                    id="checkbox-bulk"
                    v-model="form.is_bulk"
                    name="checkbox-bulk"
                    :value="true"
                    :unchecked-value="false"
                    class="mt-2 mb-2 ml-1"
                    switch
                >
                    Bulk
                </b-form-checkbox>
                <div class="modal-footer">
                    <b-button @click="onSubmit" variant="primary">Add Product Group</b-button>
                    <button type="button" class="btn btn-secondary" @click="closeModal()">Close</button>
                </div>
            </b-form>
        </b-overlay>
    </b-modal>
</template>

<script>
import { productComputed, productMethods } from "@/state/helpers";
//eslint-disable-next-line
import { validationMixin } from "vuelidate";
//eslint-disable-next-line
import { required, minLength } from "vuelidate/lib/validators";
//eslint-disable-next-line
import Swal from "sweetalert2";

export default {
    data: () => ({
        busySaving: false,
        formSubmit: false,
        form: {
            name: "",
            description: "",
            linked_product_ids: [],
            linked_role_ids: [],
            display_material: "false",
            is_bulk: false,
        },
    }),
    validations: {
        form: {
            name: {
                required,
                minLength: minLength(2),
            },
            description: {
                required,
                minLength: minLength(3),
            },
        },
    },
    computed: {
        ...productComputed,
    },
    methods: {
        ...productMethods,
        validateState(name) {
            if (this.formSubmit) {
                const { $dirty, $error } = this.$v.form[name];
                return $dirty ? !$error : null;
            }
        },
        closeModal() {
            this.$bvModal.hide("addProductGroupModal");
        },
        onSubmit() {
            //
            this.formSubmit = true;

            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }
            this.busySaving = true;

            this.saveProductGroup(this.form).then((response) => {
                this.busySaving = false;

                Swal.fire(`New Group Created`, `${this.form.name} was created`, "success");

                // this.setAllProductGroups();
                //
                //eslint-disable-next-line
                console.log(response);
                this.$router.push(`/product-groups/${response.group_id}`);

                this.closeModal();
            }).catch(() => {
                this.busySaving = false;
                Swal.fire(`Could not create group`, `You may not have permission to manage product groups, or the request failed.`, "error");
            });
        },
    },
    mounted() {
        //eslint-disable-next-line
        console.log("modal up");
    },
};
</script>
<style></style>
